<script>
  // import { AUDIO_PLAYERS } from "../util/audio-players";

  // import Header from "./Header.svelte";
  import { INTERVIEWS, LINK_EPISODES } from "../util/constants";
  import AudioPlayer from "./AudioPlayer.svelte";
  import LinkButton from "./LinkButton.svelte";
  import Paragraph from "./Paragraph.svelte";

  export let episode = null;
  // const meta = INTERVIEWS[0];
</script>

<!-- <Paragraph
  >Conversations and interviews with the artist, conducted during the project's
  research & development.</Paragraph
> -->
<Paragraph
  >Interviews with the artist, conducted during the project's research and
  development phase.</Paragraph
>
<div class="container">
  {#each INTERVIEWS as meta, i (meta.id)}
    {#if episode == null || episode == meta.episode}
      <div class="interview">
        <!-- <Paragraph>Some research interviews with the artist and notable experts in the field.</Paragraph> -->
        <!-- <div class="background-image"></div> -->
        <div class="body">
          <div class="body-info">
            <div class="caption">
              <LinkButton to={`/${LINK_EPISODES}/${i + 1}`} inline
                >EPISODE {meta.episode}</LinkButton
              >
            </div>
            <div class="header">{meta.title}</div>
            <div class="about"><Paragraph>{meta.about}</Paragraph></div>
          </div>
          <div class="play-container">
            <AudioPlayer id={meta.id}></AudioPlayer>
          </div>
        </div>
        <!-- <div class="vfx">
    <div class="play" on:click={toggleEpisode}>
      <img src={playSvg} alt="Play" />
    </div>
  </div> -->
      </div>
    {/if}
  {/each}
</div>

<style>
  .container {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 20px;
  }
  .interview {
    display: flex;
    flex-direction: row;
    flex-basis: 50%;
    border: 1px solid black;
    padding: 20px;
    /* justify-content: space-between; */
  }
  .body {
    max-width: 800px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
  }
  .play-container {
    /* flex-grow: 1; */
    /* flex-shrink: 0; */
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
  }
  .caption {
    font-size: 10px;
    margin-bottom: 5px;
  }
  .header {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: var(--one-em);
  }

  @media screen and (max-width: 720px) {
    .container {
      width: 100%;
      flex-basis: initial;
      flex-direction: column;
    }
    .header {
      max-width: 250px;
    }
  }
</style>
